import script from "./dotComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./dotComponents.vue?vue&type=script&setup=true&lang=js"

import "./dotComponents.vue?vue&type=style&index=0&id=5fa3bf8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa3bf8e"]])

export default __exports__